import { PAGE_TYPES } from '../shared/utils/analytics/constants';

export const microPrefix = 'nol-portal-home';

export function getPageType(slug) {
  if (slug === '/' || slug === '') return PAGE_TYPES.HOMEPAGE;
  if (slug === '/entre-nosotras/cuidado-femenino/') return PAGE_TYPES.ARTICLE_TOP_VIEW;
  if (slug === '/magazin/nuestro-mundo/') return PAGE_TYPES.ARTICLE_TOP_VIEW;
  if (slug.includes('/entre-nosotras/cuidado-femenino/')) return PAGE_TYPES.ARTICLE;
  if (slug.includes('/magazin/nuestro-mundo/')) return PAGE_TYPES.ARTICLE;
  if (slug === '/contactanos/') return PAGE_TYPES.CONTACT;
  if (slug.includes('/sostenibilidad')) return PAGE_TYPES.SUSTAINABILITY;

  return PAGE_TYPES.GENERIC;
}
